/**
 * Created by lihanying on 2017/6/29.
 */
import { GETCLUBSTORAGE } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBSTORAGE:
      return Object.assign({}, state, { storageList: action.payload })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubStorage/reduce.js